import EditApplicant from "./editApplicant";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  onClose: Function;
  refreshFunction?: Function;
  modalTitle?: string;
};

const EditApplicantModal = ({ toggleModal, urlTittle, onClose, refreshFunction, modalTitle }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={modalTitle}
        titleStyle={styles}
        urlTittle={urlTittle}
      >
        <EditApplicant onClose={onClose} refreshFunction={refreshFunction}/>
      </Modal>
    </>
  );
};

export default EditApplicantModal;
